import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchLevels } from "reduxStore/actions/levelActions";

function ReassignLevelDialog({ open, handleClose, handleReassignConfirm }) {
  const dispatch = useDispatch();
  const levels = useSelector((state) => state.levels.data || []);
  const [selectedLevel, setSelectedLevel] = useState("");

  useEffect(() => {
    if (open) {
      dispatch(fetchLevels({ page: 0, limit: 100, sort: "", search: "" })); // Load all levels
    }
  }, [open, dispatch]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Reassign Assessments</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel>Select New Level</InputLabel>
          <Select
            value={selectedLevel}
            onChange={(e) => setSelectedLevel(e.target.value)}
          >
            {levels.map((level) => (
              <MenuItem key={level._id} value={level._id}>
                {level.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={() => handleReassignConfirm(selectedLevel)}
          color="primary"
          disabled={!selectedLevel}
        >
          Reassign & Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReassignLevelDialog;
